import { useDataState } from '../../../hooks/useData';
export function useWebsiteInfo() {
  const [websiteInfo, setWebsiteInfo] = useDataState('websiteInfo');
  return {
    websiteInfo,
    setWebsiteInfo,
    websiteId: websiteInfo?.websiteId,
    websiteUrl: websiteInfo?.websiteUrl,
    pages: websiteInfo?.pages,
    dynamicPages: websiteInfo?.dynamicPages,
    getPage: (pageKey) => websiteInfo?.pages?.[pageKey],
  };
}
